/* global G */
import validateSequence from 'lib/sequence/model/validate'
import reset from 'lib/sequence/model/api/reset'
import find from 'lib/sequence/component/children/find'
import ui from 'lib/hook/ui/update'
import confirm from 'lib/hook/router/confirm'
import create from 'app/_shared/hook/appbar/create'
import check from 'app/_shared/hook/check'
import platform from 'app/_shared/hook/platform'
import backOrRedirect from 'app/_shared/hook/redirect/backOrRedirect'
import readTypeExtension from './hook/readTypeExtension'
import submitTypeExtension from './hook/submitTypeExtension'
import readTypeExtensionDetail from './hook/readTypeExtensionDetail'

const _indexHooks = {
  before: [
    obj => (...args) => {
      reset(obj[G.MODEL], { clear: true })
      return args
    },
  ],
  after: [
    platform({
      web: create,
    }),
    ui,
  ],
}

const _readHooks = {
  before: [
    confirm,
    platform({
      web: readTypeExtension,
      mobile: readTypeExtensionDetail,
    }),
  ],
  after: [
    ui,
  ],
}

const _submitHooks = {
  before: [
    obj => async (...args) => {
      await validateSequence(obj[G.MODEL])(find(obj[G.STATE][G.ACTION][G.COMPONENT]).form)
      return args
    },
  ],
  after: [
    ui,
    check,
    submitTypeExtension,
    backOrRedirect,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    index: _indexHooks,
    detail: _readHooks,
    submit: _submitHooks,
  },
}

export default hooks
